import {
    BatchListPayload,
    GetRoutinePayload,
    PaymentUserPayload,
    StudentTransactionRequest,
    UserSearchParameter,
    WithdrawUserPayload
} from '../types';
export const batchKeys = {
    all: ['batches'] as const,
    lists: () => [...batchKeys.all, 'list'] as const,
    list: (filters: BatchListPayload) => [...batchKeys.lists(), filters] as const,
    details: () => [...batchKeys.all, 'detail'] as const,
    detail: (id: string) => [...batchKeys.details(), id] as const
};

export const tabKeys = {
    all: ['tabs'] as const,
    lists: () => [...tabKeys.all, 'list'] as const,
    list: (filters: string) => [...tabKeys.lists(), filters] as const,
    details: () => [...tabKeys.all, 'detail'] as const,
    detail: (id: string) => [...tabKeys.details(), id] as const
};

export const userKeys = {
    all: ['users'] as const,
    lists: () => [...userKeys.all, 'list'] as const,
    list: (filters: string | UserSearchParameter, userType?: string) =>
        [
            ...userKeys.lists(),
            {
                filters,
                userType: userType
            }
        ] as const,
    details: () => [...userKeys.all, 'detail'] as const,
    detail: (id: string) => [...userKeys.details(), id] as const
};
export const userNameExistenceKeys = {
    all: ['usernameExists'] as const,
    lists: () => [...userNameExistenceKeys.all, 'list'] as const,
    list: (filters: string) => [...userNameExistenceKeys.lists(), { filters }] as const,
    details: () => [...userNameExistenceKeys.all, 'detail'] as const,
    detail: (id: string) => [...userNameExistenceKeys.details(), id] as const
};

export const notificationKeys = {
    all: ['notifications'] as const,
    lists: () => [...notificationKeys.all, 'list'] as const,
    list: (filters: string | { organizationId: string }) => [...notificationKeys.lists(), { filters }] as const,
    details: () => [...notificationKeys.all, 'detail'] as const,
    detail: (id: string) => [...notificationKeys.details(), id] as const
};

export const attendanceDetailsKeys = {
    all: ['attendanceDetails'] as const,
    lists: () => [...attendanceDetailsKeys.all, 'list'] as const,
    list: (filters: string) => [...attendanceDetailsKeys.lists(), { filters }] as const,
    details: () => [...attendanceDetailsKeys.all, 'detail'] as const,
    detail: (id: string) => [...attendanceDetailsKeys.details(), id] as const
};

export const menuKeys = {
    all: ['menu'] as const,
    lists: () => [...menuKeys.all, 'list'] as const,
    list: (filters: string) => [...menuKeys.lists(), { filters }] as const,
    details: () => [...menuKeys.all, 'detail'] as const,
    detail: (id: string) => [...menuKeys.details(), id] as const
};

export const userBillKeys = {
    all: ['userBills'] as const,
    lists: () => [...userBillKeys.all, 'list'] as const,
    list: (
        filters:
            | string
            | PaymentUserPayload
            | {
                  [key: string]: string;
              }
    ) => [...userBillKeys.lists(), { filters }] as const,
    details: () => [...userBillKeys.all, 'detail'] as const,
    detail: (id: string) => [...userBillKeys.details(), id] as const,
    status: (id: string) => [...userBillKeys.all, 'status', id] as const
};

export const collectionKeys = {
    all: ['collections'] as const,
    lists: () => [...collectionKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...collectionKeys.lists(), { filters }] as const,
    details: () => [...collectionKeys.all, 'detail'] as const,
    detail: (id: string) => [...collectionKeys.details(), id] as const
};

export const branchKeys = {
    all: ['branches'] as const,
    lists: () => [...branchKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...branchKeys.lists(), { filters }] as const,
    details: () => [...branchKeys.all, 'detail'] as const,
    detail: (id: string) => [...branchKeys.details(), id] as const
};

export const organizationKeys = {
    all: ['organizations'] as const,
    lists: () => [...organizationKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...organizationKeys.lists(), { filters }] as const,
    details: () => [...organizationKeys.all, 'detail'] as const,
    detail: (id: string) => [...organizationKeys.details(), id] as const
};

export const organizationRolesKeys = {
    all: ['organizationsRoles'] as const,
    lists: () => [...organizationRolesKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...organizationRolesKeys.lists(), { filters }] as const,
    details: () => [...organizationRolesKeys.all, 'detail'] as const,
    detail: (id: string) => [...organizationRolesKeys.details(), id] as const
};

export const dueKeys = {
    all: ['dues'] as const,
    lists: () => [...dueKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...dueKeys.lists(), { filters }] as const,
    details: () => [...dueKeys.all, 'detail'] as const,
    detail: (id: string) => [...dueKeys.details(), id] as const
};

export const teacherTransactions = {
    all: ['userWithdrawBills'] as const,
    lists: () => [...teacherTransactions.all, 'list'] as const,
    list: (
        filters:
            | string
            | WithdrawUserPayload
            | {
                  [key: string]: string;
              }
    ) => [...teacherTransactions.lists(), { filters }] as const,
    details: () => [...teacherTransactions.all, 'detail'] as const,
    detail: (id: string) => [...teacherTransactions.details(), id] as const,
    status: (id: string) => [...teacherTransactions.all, 'status', id] as const
};

export const withdrawKeys = {
    all: ['withdraws'] as const,
    lists: () => [...withdrawKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...withdrawKeys.lists(), { filters }] as const,
    details: () => [...withdrawKeys.all, 'detail'] as const,
    detail: (id: string) => [...withdrawKeys.details(), id] as const
};

export const batchFeeKeys = {
    all: ['batchFees'] as const,
    lists: () => [...batchFeeKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...batchFeeKeys.lists(), { filters }] as const,
    details: () => [...batchFeeKeys.all, 'detail'] as const,
    detail: (id: string) => [...batchFeeKeys.details(), id] as const
};

export const studentTransactionKeys = {
    all: ['studentTransactions'] as const,
    lists: () => [...studentTransactionKeys.all, 'list'] as const,
    list: (
        filters:
            | string
            | StudentTransactionRequest
            | {
                  [key: string]: string;
              }
    ) => [...studentTransactionKeys.lists(), { filters }] as const,
    details: () => [...studentTransactionKeys.all, 'detail'] as const,
    detail: (id: string) => [...studentTransactionKeys.details(), id] as const
};
export const paymentFrequencyKeys = {
    all: ['paymentFrequencys'] as const,
    lists: () => [...paymentFrequencyKeys.all, 'list'] as const,
    list: (filters: BatchListPayload) => [...paymentFrequencyKeys.lists(), filters] as const,
    details: () => [...paymentFrequencyKeys.all, 'detail'] as const,
    detail: (id: string) => [...paymentFrequencyKeys.details(), id] as const
};
export const chargeEventsListKeys = {
    all: ['chargeEventsLists'] as const,
    lists: () => [...chargeEventsListKeys.all, 'list'] as const,
    list: (filters: BatchListPayload) => [...chargeEventsListKeys.lists(), filters] as const,
    details: () => [...chargeEventsListKeys.all, 'detail'] as const,
    detail: (id: string) => [...chargeEventsListKeys.details(), id] as const
};

// ================================================================
// ======================== KHAMAR Bondhu =========================
// ================================================================

export const contentKeys = {
    all: ['contents'] as const,
    lists: () => [...contentKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...contentKeys.lists(), { filters }] as const,
    details: () => [...contentKeys.all, 'detail'] as const,
    detail: (id: string) => [...contentKeys.details(), id] as const
};

export const divisionKeys = {
    all: ['divisions'] as const,
    lists: () => [...divisionKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...divisionKeys.lists(), { filters }] as const,
    details: () => [...divisionKeys.all, 'detail'] as const,
    detail: (id: string) => [...divisionKeys.details(), id] as const
};

export const geoLocationKeys = {
    all: ['geoLocations'] as const,
    lists: () => [...geoLocationKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...geoLocationKeys.lists(), { filters }] as const,
    details: () => [...geoLocationKeys.all, 'detail'] as const,
    detail: (id: string) => [...geoLocationKeys.details(), id] as const
};

export const userAddressKeys = {
    all: ['userAddresses'] as const,
    lists: () => [...userAddressKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...userAddressKeys.lists(), { filters }] as const,
    details: () => [...userAddressKeys.all, 'detail'] as const,
    detail: (id: string) => [...userAddressKeys.details(), id] as const
};

export const scheduleKeys = {
    all: ['schedules'] as const,
    lists: () => [...scheduleKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...scheduleKeys.lists(), { filters }] as const,
    details: () => [...scheduleKeys.all, 'detail'] as const,
    detail: (id: string) => [...scheduleKeys.details(), id] as const
};

export const videoKeys = {
    all: ['videos'] as const,
    lists: () => [...videoKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...videoKeys.lists(), { filters }] as const,
    details: () => [...videoKeys.all, 'detail'] as const,
    detail: (id: string) => [...videoKeys.details(), id] as const
};

export const userManualContentKeys = {
    all: ['userManualLists'] as const,
    lists: () => [...userManualContentKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...userManualContentKeys.lists(), { filters }] as const,
    details: () => [...userManualContentKeys.all, 'detail'] as const,
    detail: (id: string) => [...userManualContentKeys.details(), id] as const
};

export const feedbackKeys = {
    all: ['feedbacks'] as const,
    lists: () => [...feedbackKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...feedbackKeys.lists(), { filters }] as const,
    details: () => [...feedbackKeys.all, 'detail'] as const,
    detail: (id: string) => [...feedbackKeys.details(), id] as const
};

export const systemContentKeys = {
    all: ['systemContentLists'] as const,
    lists: () => [...systemContentKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...systemContentKeys.lists(), { filters }] as const,
    details: () => [...systemContentKeys.all, 'detail'] as const,
    detail: (id: string) => [...systemContentKeys.details(), id] as const
};

export const symptomContentKeys = {
    all: ['symptomContentLists'] as const,
    lists: () => [...symptomContentKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...symptomContentKeys.lists(), { filters }] as const,
    details: () => [...symptomContentKeys.all, 'detail'] as const,
    detail: (id: string) => [...symptomContentKeys.details(), id] as const
};

export const diseaseContentKeys = {
    all: ['diseaseContentLists'] as const,
    lists: () => [...diseaseContentKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...diseaseContentKeys.lists(), { filters }] as const,
    details: () => [...diseaseContentKeys.all, 'detail'] as const,
    detail: (id: string) => [...diseaseContentKeys.details(), id] as const
};

export const animalContentKeys = {
    all: ['animalContentLists'] as const,
    lists: () => [...animalContentKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...animalContentKeys.lists(), { filters }] as const,
    details: () => [...animalContentKeys.all, 'detail'] as const,
    detail: (id: string) => [...animalContentKeys.details(), id] as const
};

export const animalTypeContentKeys = {
    all: ['animalTypeContentLists'] as const,
    lists: () => [...animalTypeContentKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...animalTypeContentKeys.lists(), { filters }] as const,
    details: () => [...animalTypeContentKeys.all, 'detail'] as const,
    detail: (id: string) => [...animalTypeContentKeys.details(), id] as const
};

export const analyticsCardsDataKeys = {
    all: ['analyticsCardsDataLists'] as const,
    lists: () => [...analyticsCardsDataKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...analyticsCardsDataKeys.lists(), { filters }] as const,
    details: () => [...analyticsCardsDataKeys.all, 'detail'] as const,
    detail: (id: string) => [...analyticsCardsDataKeys.details(), id] as const
};

export const totalGrowthLinedataKeys = {
    all: ['totalGrowthLineData'] as const,
    lists: () => [...totalGrowthLinedataKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...totalGrowthLinedataKeys.lists(), { filters }] as const,
    details: () => [...totalGrowthLinedataKeys.all, 'detail'] as const,
    detail: (id: string) => [...totalGrowthLinedataKeys.details(), id] as const
};

export const districtWiseTotalGrowthLinedataKeys = {
    all: ['districtWiseTotalGrowthLineData'] as const,
    lists: () => [...districtWiseTotalGrowthLinedataKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...districtWiseTotalGrowthLinedataKeys.lists(), { filters }] as const,
    details: () => [...districtWiseTotalGrowthLinedataKeys.all, 'detail'] as const,
    detail: (id: string) => [...districtWiseTotalGrowthLinedataKeys.details(), id] as const
};

export const diseaseWiseTotalGrowthLinedataKeys = {
    all: ['diseaseWiseTotalGrowthLineData'] as const,
    lists: () => [...diseaseWiseTotalGrowthLinedataKeys.all, 'list'] as const,
    list: (filters: string | { [key: string]: string }) => [...diseaseWiseTotalGrowthLinedataKeys.lists(), { filters }] as const,
    details: () => [...diseaseWiseTotalGrowthLinedataKeys.all, 'detail'] as const,
    detail: (id: string) => [...diseaseWiseTotalGrowthLinedataKeys.details(), id] as const
};
